import styled from 'styled-components';

const PrivacyPolicyForm = () => {
  return (
    <>
      <Wrap>
        <h1>콘플래너 개인정보 처리방침</h1>
        <h2>1. 개인정보 수집 및 이용</h2>
        <p>당사는 다음과 같은 목적을 위해 개인정보를 수집·이용합니다.</p>
        <table>
          <tbody>
            <tr>
              <th>수집 목적</th>
              <td>회원가입 및 서비스 제공</td>
            </tr>
            <tr>
              <th>수집 항목</th>
              <td>
                <span style={{ fontWeight: 700 }}>
                  필수: 아이디, 비밀번호, 휴대폰 번호, 닉네임, 번호 및 사번,
                  차량번호, 접속정보(IP, 쿠키 등)
                </span>
                <span>선택: 자기소개, 방 상세 초상 등</span>
              </td>
            </tr>
            <tr>
              <th>보유 및 이용 기간</th>
              <td>
                회원 탈퇴 시까지 (단, 관계 법령에 따라 보관이 필요한 경우 해당
                법령에 따름)
              </td>
            </tr>
          </tbody>
        </table>
        <h2>2. 민감정보 수집</h2>
        <p>
          당사는 소속기관, 게시물 내 초상 등 민감정보를 서비스 제공을 위한
          최소한의 범위에서 수집하며, 별도의 동의를 받습니다.
        </p>
        <h2>3. 개인정보 제3자 제공</h2>
        <table>
          <tbody>
            <tr>
              <th>제공받는 자</th>
              <td>대한</td>
            </tr>
            <tr>
              <th>제공 항목</th>
              <td>소속기관, 닉네임, 게시물 및 초상 포함 이용정보</td>
            </tr>
            <tr>
              <th>제공 목적</th>
              <td>입출차 관리, 서비스 개선 및 정책 연구</td>
            </tr>
            <tr>
              <th>보유 기간</th>
              <td>이용 목적 달성 시</td>
            </tr>
          </tbody>
        </table>
        <h2>4. 개인정보 처리 위탁</h2>
        <p>
          현재 개인정보 처리 위탁은 없습니다. 향후 위탁 발생 시 관련 내용을 본
          방침에 추가 고지하겠습니다.
        </p>
        <h2>5. 회원 탈퇴 및 데이터 삭제 요청</h2>
        <p>회원은 아래 절차에 따라 탈퇴 또는 데이터 삭제 요청이 가능합니다.</p>
        <p>
          - 본인 계정 확인
          <br />
          - 콘플래너 앱 운영 주체(대한)에 유선 연락
          <br />- 본인 확인 후 탈퇴 또는 삭제 요청
        </p>
        <h2>6. 개인정보관리 책임자 및 문의처</h2>
        <p>
          본 방침과 관련된 문의는 아래로 연락주시기 바랍니다.
          <br />- 책임자: 고성의
          <br />- 이메일: a30005567@gmail.com
          <br />- 대표전화: 010-3000-5567
        </p>
        <h2>7. 약관 변경 고지</h2>
        <p>
          본 개인정보 처리방침은 변경될 수 있으며, 변경 시 앱 내 공지사항 또는
          이메일 등을 통해 사전 고지합니다.
        </p>
        <p>
          <small>최종 업데이트: 2025년 4월</small>
        </p>
      </Wrap>
    </>
  );
};

export default PrivacyPolicyForm;

const Wrap = styled.div`
  padding: clamp(1rem, 2vw, 2rem);
  line-height: 1.6;
  h2 {
    margin-top: clamp(1.5rem, 3vw, 2rem);
    font-size: clamp(1.25rem, 2.5vw, 1.5rem);
  }
  h1 {
    font-size: clamp(1.5rem, 3vw, 2rem);
  }
  p {
    font-size: clamp(0.875rem, 1.5vw, 1rem);
  }
  table {
    border-collapse: collapse;
    width: 100%;
    margin: clamp(0.75rem, 1.5vw, 1rem) 0;
    th {
      background-color: #f9f9f9;
      white-space: nowrap;
      font-size: clamp(0.875rem, 1.5vw, 1rem);
    }
    th,
    td {
      border: 1px solid #ddd;
      padding: clamp(0.5rem, 1vw, 0.75rem);
      text-align: left;
      font-size: clamp(0.875rem, 1.5vw, 1rem);
    }
  }
  @media (max-width: 768px) {
    padding: 1rem;
    table {
      display: block;
      overflow-x: auto;
    }
  }
`;
